module.exports = __webpack_public_path__ + "static/img/14000596.ae5b4d53.png";